<template>
  <a-modal
      title="预览"
      width="large"
      :visible="visible"
      :dialog-style="{ top: '0', bottom: '0' }"
      :body-style="{padding: '15px', minHeight: '300px', background: '#eee'}"
      :footer="null"
      @cancel="visible=false"
  >
    <PreviewR
      ref="previewR"
      :params="params"
    />
  </a-modal>
</template>

<script>
import PreviewR from './PreviewR.vue'
export default {
  components: {
    PreviewR
  },
  data () {
    return {
      params: {
        img: {},
        cropX: 0,
        cropY: 0,
        cropW: 0,
        cropH: 0,
        frameX: 0,
        frameY: 0,
        frameWidth: 0,
        frameHeight: 0,
        colorX: 0,
        colorY: 0
      },
      visible: false
    }
  },
  methods: {
    // 窗口
    // {width, height, }
    show (params) {
      Object.assign(this.params, params)
      this.visible = true
      this.$nextTick(_ => {
        this.$refs.previewR.update()
      })
    },
    hide () {
      this.visible = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/design/PopPreview.vue